import styled from 'styled-components';

export const PropertyDropdownWrapper = styled.div`
    margin-top: 2rem;
`